import { nextTick } from 'vue'
import router from '@/router/index'
import { store } from '@/store/index.ts'
// import { i18n } from '/@/i18n/index'

/**
 * 设置浏览器标题国际化
 */
export function useTitle () {
  return () => {
    nextTick(() => {
      let webTitle = ''
      const globalTitle: string = store.state.themeConfig.themeConfig.globalTitle
      router.currentRoute.value.path === '/login'
        ? (webTitle = router.currentRoute.value.meta.title as any)
        : (webTitle = 'aaa')
        // : (webTitle = i18n.global.t(router.currentRoute.value.meta.title as any))
      document.title = `${webTitle} - ${globalTitle}` || globalTitle
    })
  }
}
